module.exports='{{? it.records[0].valueMap.suggestkeyword.length > 0}}<a target="_blank" class="hot-search-tips">大家都在搜:</a>{{~it.records:record:index}}{{?record.valueMap.suggestkeyword}}<a target="_blank" href="{{=it.domain}}/search/keyword/{{=it.cityId}}/{{=it.cateId}}_{{=record.valueMap.suggestkeyword}}"class="search-word">{{=record.valueMap.suggestkeyword}}</a>{{?}}{{~}}{{?}}';


// WEBPACK FOOTER //
// ./modules/tpl/hot-search.html.js